import React from 'react';
import ContentLayout, { H2, Prose } from '../components/ContentLayout';
import SmartImage from '../components/SmartImage';
import IMG1 from '../assets/anand/anand-meditative.jpg';
import IMG2 from '../assets/anand/anand-joy.jpg';
import IMG3 from '../assets/anand/anand-embrace.jpg';

const AboutAnandArun = () => (
  <ContentLayout
    testid="page-anand-arun"
    eyebrow="Our Lineage"
    titleTop="Bodhisattva Swami"
    titleItalic="Anand Arun"
    intro="Ordinary to Beyond Extraordinary — Swami Arun always insists on calling himself an ordinary man and humbly points towards his master for all that has manifested around him. And what has manifested is beyond extraordinary!"
  >
    <div className="grid grid-cols-3 gap-3 mb-12">
      <SmartImage src={IMG1} alt="Swami Anand Arun" className="rounded-2xl aspect-square" />
      <SmartImage src={IMG2} alt="Swami Anand Arun" className="rounded-2xl aspect-square" />
      <SmartImage src={IMG3} alt="Swami Anand Arun" className="rounded-2xl aspect-square" />
    </div>

    <H2 top="How He Inspired Osho" italic="Kaivalya Dham" />
    <Prose>
      <p>Swami Anand Arun had been visiting Dallas, TX from the year 2007. In 2008 — the first time Swami Prem Maitreya met him — the opportunity arose to take Sannyas. After Sannyas, Swami Prem asked Swamiji who would give Sannyas after him, because it had taken 14 long years to find someone to be initiated into Osho Neo Sannyas. That blessing became the seed of Osho Kaivalya Dham.</p>
    </Prose>

    <div className="mt-12">
      <H2 top="Worldwide Influence &" italic="Living Legacy" />
      <Prose>
        <p>Swami Anand Arun, one of the most influential spiritual figures from Nepal, began his journey as a young seeker drawn to meditation and higher consciousness. His life transformed in 1969 when he met his master, Osho, during his engineering studies. In 1974 he took formal initiation, becoming Swami Anand Arun.</p>
        <p>Following Osho’s guidance, he established Osho Tapoban International Commune in Nepal, which later expanded into more than 100 Osho centers worldwide. Known for his humility, Swami Arun calls himself “an ordinary man,” yet his contributions have impacted millions across the globe. Celebrated as a meditation teacher, author, life coach, and visionary, he has been honored as one of Nepal’s 100 most influential people.</p>
        <p>The President of Nepal awarded him the prestigious Prabal Janasewa Shree for his work in promoting meditation, mental health awareness, youth transformation, and environmental protection — especially his famous “Plant a Tree on Your Birthday” movement. He is also the author of several bestselling books, including Lone Seeker Many Masters, In Wonder With Osho, and Satsang. His teachings continue to guide seekers worldwide toward meditation, clarity, and conscious living.</p>
      </Prose>
    </div>
  </ContentLayout>
);

export default AboutAnandArun;
